export const getAnimationConfig = (styles, device, defaultAnimation, defaultAnimationOptions) => {
    let config;
    const deviceStyles = styles[device];
    if (defaultAnimation && defaultAnimationOptions) {
        config = {
            animation: defaultAnimation,
            animationOptions: defaultAnimationOptions,
        };
    }
    else if (deviceStyles && deviceStyles.animation && deviceStyles.animationOptions) {
        config = {
            animation: deviceStyles.animation,
            animationOptions: deviceStyles.animationOptions,
        };
    }
    else {
        config = null;
    }
    return config;
};
//# sourceMappingURL=getAnimationConfig.js.map